import { api } from "../../services/NetworkBase";

// Inventory Tracker (ENB-584)

// Pulls the API's message out of a failed call so screens can show why (e.g. "Only 3 on hand").
export async function GetErrorMessage(error, fallback) {
  try {
    const body = await error?.response?.json();
    return body?.message || fallback;
  } catch {
    return fallback;
  }
}

export async function GetInventoryLocations(includeInactive = false) {
  try {
    let response = await api
      .get(`vlp/inventory-tracker/locations?includeInactive=${includeInactive}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveInventoryLocation(location) {
  try {
    let response = await api.post("vlp/inventory-tracker/locations", { json: location }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateInventoryLocation(location) {
  try {
    let response = await api.put("vlp/inventory-tracker/locations", { json: location }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteInventoryLocation(id) {
  try {
    let response = await api.delete(`vlp/inventory-tracker/locations/${id}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function LookupInventoryCode(code) {
  try {
    let response = await api
      .get(`vlp/inventory-tracker/lookup?code=${encodeURIComponent(code)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetInventoryStock(locationId = "", productId = "", searchText = "") {
  try {
    // The ids bind to nullable ints on the API, so leave them off when blank.
    const params = new URLSearchParams();
    if (locationId) params.append("locationId", locationId);
    if (productId) params.append("productId", productId);
    if (searchText) params.append("searchText", searchText);
    let response = await api.get(`vlp/inventory-tracker/stock?${params.toString()}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PostInventoryMovement(movement) {
  try {
    let response = await api.post("vlp/inventory-tracker/movements", { json: movement }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetInventoryTransactions(transactionType = "", fromDate = "", toDate = "", productId = "") {
  try {
    const params = new URLSearchParams();
    if (transactionType) params.append("transactionType", transactionType);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);
    if (productId) params.append("productId", productId);
    let response = await api.get(`vlp/inventory-tracker/transactions?${params.toString()}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetInventoryReorderReport() {
  try {
    let response = await api.get("vlp/inventory-tracker/reorder").json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetInventoryReorderNotice() {
  try {
    let response = await api.get("vlp/inventory-tracker/reorder-notice").json();
    return response;
  } catch (error) {
    throw error;
  }
}
